import { LocationProvider, Router, Route } from 'preact-iso';
import { isAuthenticated } from './api';
import { PageLayout } from './components/layout/PageLayout';
import { Dashboard } from './pages/Dashboard';
import { Database } from './pages/Database';
import { Staging } from './pages/Staging';
import { Queue } from './pages/Queue';
import { History } from './pages/History';
import { Login } from './pages/Login';

function ProtectedRoute({ component: Component, page }: { component: () => any; page: string }) {
  if (!isAuthenticated()) {
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
    return null;
  }
  return (
    <PageLayout activePage={page}>
      <Component />
    </PageLayout>
  );
}

export function App() {
  return (
    <LocationProvider>
      <Router>
        <Route path="/" component={() => <ProtectedRoute component={Dashboard} page="dashboard" />} />
        <Route path="/database" component={() => <ProtectedRoute component={Database} page="database" />} />
        <Route path="/staging" component={() => <ProtectedRoute component={Staging} page="staging" />} />
        <Route path="/queue" component={() => <ProtectedRoute component={Queue} page="queue" />} />
        <Route path="/history" component={() => <ProtectedRoute component={History} page="history" />} />
        <Route path="/login" component={Login} />
      </Router>
    </LocationProvider>
  );
}
